import {Outlet} from "react-router-dom";
import {MenuApp} from "../menuApp/MenuApp";

export function BaseLayout() {
    return (
        <div className="app">
            <Outlet/>

            <MenuApp/>
        </div>
    )
}